export default { sha: 'd983cf0db4cb951134247df20e5623f0842fcc4d', buildNumber: 'undefined' }
